import React from 'react';
import { motion } from 'framer-motion';
import { StethoscopeIcon, PipeWrenchIcon } from './PlumbingIcons';
export function HeroSection() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex flex-col lg:flex-row items-center justify-center overflow-hidden bg-dark lg:min-h-screen" data-id="element-239">
      {/* Mobile Image Top — shorter, with text overlapping via negative margin */}
      <div className="lg:hidden w-full h-[35vh] relative flex-shrink-0" data-id="element-240">
        <img src="https://cdn.magicpatterns.com/uploads/wdWGXTt2aSSkADD3PxX89h/heylloyd-image-1773461464719.png" alt="Plomero Profesional" className="w-full h-full object-cover object-top" data-id="element-241" />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/30 via-dark/70 to-dark" data-id="element-242" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center px-5 sm:px-6 -mt-16 lg:mt-0 pt-0 lg:pt-32 pb-12 lg:pb-20 gap-6 lg:gap-12" data-id="element-243">
        {/* Text Content */}
        <div className="w-full lg:w-1/2 text-center lg:text-left relative z-20" data-id="element-244">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-245">
            <h1 className="text-[1.65rem] sm:text-3xl md:text-5xl lg:text-7xl font-black tracking-tight leading-[1.15] mb-4 lg:mb-6" data-id="element-246">
              <span className="text-gold" data-id="element-247">Emergencias de plomería</span> hay
              todos los días.
              <br className="hidden md:block" data-id="element-248" /> Si tu teléfono no suena, es
              porque{' '}
              <span className="text-gold" data-id="element-249">tu marketing está obstruido.</span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-250">
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 mb-6 lg:mb-10 font-medium leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-251">
              Inyectamos{' '}
              <span className="text-white font-bold" data-id="element-252">
                Leads Exclusivos de Alta Presión.
              </span>{' '}
              No compartidos, no basura. Solo llamadas de emergencia directo a
              tu despacho.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col items-center lg:items-start gap-4" data-id="element-253">
            <button onClick={scrollToContact} className="group relative inline-flex items-center justify-center px-6 py-4 sm:px-8 sm:py-5 text-sm sm:text-base md:text-xl font-black text-dark bg-gold rounded-full overflow-hidden transition-all hover:scale-105 shadow-neon-green hover:shadow-neon-green-lg w-full md:w-auto" data-id="element-254">
              <span className="relative z-10 flex items-center gap-2 sm:gap-3" data-id="element-255">
                CORREGIR MI FLUJO DE CLIENTES
                <motion.span animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 1.5,
                repeat: Infinity
              }} data-id="element-256">
                  →
                </motion.span>
              </span>
              <div className="absolute inset-0 h-full w-full bg-white/20 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300 ease-out" data-id="element-257" />
            </button>

            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-emerald hover:text-gold transition-colors font-semibold underline underline-offset-4 flex items-center gap-2 text-sm sm:text-base" data-id="element-258">
              <span className="hidden sm:inline" data-id="element-259">
                O agenda tu cita directamente en nuestro calendario
              </span>
              <span className="sm:hidden" data-id="element-260">
                Agenda tu cita en nuestro calendario
              </span>
            </a>
          </motion.div>
        </div>

        {/* Image Content (Right on Desktop only) */}
        <div className="hidden lg:block w-1/2 relative" data-id="element-261">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-emerald/20 blur-[100px] rounded-full pointer-events-none" data-id="element-262" />
          <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-gold/10 blur-[80px] rounded-full pointer-events-none" data-id="element-263" />

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: 'easeOut'
        }} className="relative z-10 rounded-2xl overflow-hidden border border-emerald/30 shadow-neon-green" data-id="element-264">
            <img src="https://cdn.magicpatterns.com/uploads/wdWGXTt2aSSkADD3PxX89h/heylloyd-image-1773461464719.png" alt="Plomero Profesional" className="w-full h-auto object-cover" data-id="element-265" />
            <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent" data-id="element-266" />

            <motion.div className="absolute bottom-6 left-6 bg-dark/80 backdrop-blur-md border border-emerald/50 p-4 rounded-xl flex items-center gap-4 shadow-neon-green" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-267">
              <div className="w-12 h-12 rounded-full bg-emerald/20 flex items-center justify-center" data-id="element-268">
                <StethoscopeIcon size={24} className="text-emerald" data-id="element-269" />
              </div>
              <div data-id="element-270">
                <p className="text-white font-bold" data-id="element-271">Diagnóstico Preciso</p>
                <p className="text-emerald text-sm" data-id="element-272">Leads 100% Filtrados</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}